// KL guide in Bahasa Melayu: aircond tak sejuk. hreflang pair with the
// English /aircond-not-cold page. Written in Malay, not machine-translated.
const content = {
    lang: 'ms',
    slug: 'aircond-tak-sejuk',
    title: 'Aircond Tak Sejuk? 7 Punca dan Cara Atasi | StringsSG',
    description: (c) =>
        `Aircond tak sejuk? Ketahui punca biasa, langkah semakan sendiri dan kos membaikinya di KL - servis dari ${c.money(c.tables.general[0].wall)}, chemical wash ${c.money(c.tables.chemicalWash[0].wall)}.`,
    eyebrow: 'KL · Panduan aircond',
    h1: 'Aircond Tak Sejuk? Punca dan Cara Mengatasinya',
    lead: 'Aircond berbunyi, kipas berpusing, tetapi bilik masih panas. Kebanyakan masa puncanya mudah - penapis atau coil yang kotor. Berikut cara mengenal pasti punca sebenar sebelum anda memanggil juruteknik.',
    datePublished: '2026-10-03',
    image: 'blog/living/cool-air-from-aircon.jpg',
    imageAlt: 'Memeriksa angin aircond yang tidak sejuk',
    summary: {
        title: 'Ringkasan',
        items: [
            'Punca paling biasa: penapis dan coil kotor.',
            'Kalau angin langsung tak sejuk, periksa unit luar (compressor).',
            'Gas hanya berkurang jika ada kebocoran.',
            'Cuba semakan mudah dahulu sebelum menempah servis.',
        ],
    },
    sections: [
        {
            title: '7 punca aircond tak sejuk',
            cards: [
                { title: '1. Penapis kotor', body: 'Penapis yang penuh habuk menyekat angin. Bilik lambat sejuk walaupun aircond dipasang lama.' },
                { title: '2. Coil kotor dan berkulat', body: 'Dalam cuaca lembap Malaysia, habuk melekat pada coil yang basah. Angin jadi lemah dan berbau.' },
                { title: '3. Gas berkurang', body: 'Angin sekadar dingin, ada ais pada paip. Biasanya kerana kebocoran pada sambungan paip.' },
                { title: '4. Kapasitor rosak', body: 'Kipas dalam berpusing tetapi unit luar senyap. Alat ganti kecil, mudah diganti.' },
                { title: '5. Unit luar tersumbat', body: 'Daun, habuk atau barang di koridor/ledge menghalang haba keluar.' },
                { title: '6. Saiz HP tidak sesuai', body: 'Aircond 1.0hp di bilik besar atau bilik menghadap barat memang sukar menyejukkan pada waktu petang.' },
                { title: '7. Tetapan salah', body: 'Mod Dry, Fan atau Auto, atau suhu ditetapkan terlalu tinggi.' },
            ],
        },
        {
            title: 'Semakan yang boleh anda buat sendiri',
            steps: [
                { title: 'Periksa mod dan suhu', body: 'Pastikan mod Cool (ikon salji) dan tetapkan 24°C.' },
                { title: 'Cuci penapis', body: 'Buka panel depan, keluarkan penapis, bilas dengan air dan keringkan sebelum dipasang semula.' },
                { title: 'Lihat unit luar', body: 'Adakah kipasnya berpusing? Alihkan apa-apa yang menghalang.' },
                { title: 'Tunggu 20 minit', body: 'Rasa angin di bahagian keluar. Sejuk tetapi lemah = kotor. Tidak sejuk langsung = perlu juruteknik.' },
            ],
        },
        {
            title: 'Berapa kos membaikinya?',
            table: {
                columns: [
                    { key: 'kerja', label: 'Kerja' },
                    { key: 'harga', label: 'Harga (1 unit)' },
                ],
                rows: (c) => [
                    { kerja: 'Servis biasa (general service)', harga: c.money(c.tables.general[0].wall) },
                    { kerja: 'Chemical wash', harga: c.money(c.tables.chemicalWash[0].wall) },
                    { kerja: 'Tambah gas R32', harga: c.money(c.tables.gas.R32.half) },
                    { kerja: 'Lawatan diagnosis kerosakan', harga: c.money(c.tables.repairDiagnosis) },
                ],
            },
        },
    ],
    faqs: [
        {
            question: 'Kenapa aircond saya hidup tetapi tak sejuk?',
            answer: 'Biasanya kerana penapis atau coil kotor. Jika masih tak sejuk selepas penapis dicuci, mungkin gas berkurang atau kapasitor unit luar rosak.',
        },
        {
            question: 'Perlukah saya tambah gas setiap kali servis?',
            answer: 'Tidak. Sistem yang tidak bocor menyimpan gas bertahun-tahun. Jika perlu tambah gas berulang kali, kebocoran perlu dibaiki.',
        },
        {
            question: 'Berapa kerap aircond perlu diservis?',
            answer: 'Setiap tiga hingga empat bulan untuk unit yang digunakan setiap malam, dan chemical wash sekali setahun.',
        },
    ],
    alternates: [
        { hreflang: 'en-my', path: '/my/aircond-service-kuala-lumpur/aircond-not-cold' },
        { hreflang: 'ms-my', path: '/my/aircond-service-kuala-lumpur/aircond-tak-sejuk' },
    ],
    relatedLinks: [
        { href: '/my/aircond-service-kuala-lumpur/aircond-not-cold', title: 'Read in English: Aircond Not Cold' },
    ],
    cta: {
        title: 'Tempah servis aircond di KL',
        body: 'Harga tetap, termasuk pengangkutan. Tempah dalam talian dan sahkan dalam aplikasi StringsSG.',
        href: '/my/aircond-service-kuala-lumpur/aircond-chemical-wash',
        label: 'Lihat harga chemical wash',
        bookSummary: 'servis aircond tak sejuk di KL',
        bookLabel: 'Tempah sekarang',
    },
}

export default content
